/**
 * O card "Cadê o carro?" — na Home (durante) e no Mapa: nota, quem marcou e
 * quando, a foto da fileira (se houver), "Como chegar" e "Peguei o carro".
 */
import { useState } from 'react';

import { useTrip } from '../../trip/TripContext';
import { Icon } from '../../ui/icons';
import { Card } from '../../ui/primitives';
import { ComoChegar } from '../mapa/ComoChegar';
import { type Carro, carroApi, useInvalidarCarro } from './api';

function hora(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
}

/**
 * `comMapa` (tela Cadê o carro): o card ganha, no alto, uma área de mapa
 * ilustrada com o pino — é decoração, o mapa de verdade é o "Como chegar".
 */
export function CarroCard({ carro, comMapa = false, onPeguei }: { carro: Carro; comMapa?: boolean; onPeguei?: () => void }) {
  const { tripId, meuMemberId } = useTrip();
  const avisar = useInvalidarCarro(tripId);
  const [mexendo, setMexendo] = useState(false);
  const [ampliada, setAmpliada] = useState(false);

  async function peguei() {
    setMexendo(true);
    try {
      await carroApi.peguei(tripId, carro.id);
      onPeguei?.();
      avisar();
    } finally {
      setMexendo(false);
    }
  }

  return (
    <Card className={comMapa ? 'carro carro--mapa nv-pop' : 'carro'} data-testid="carro">
      {comMapa && (
        <div className="carro__mapa" aria-hidden="true">
          <span className="carro__pino"><Icon name="carro" size={20} /></span>
        </div>
      )}
      <div className="enc__cab">
        {!comMapa && <span className="carro__icone" aria-hidden="true"><Icon name="carro" size={18} /></span>}
        <span className="mapa__pessoa-texto">
          <span className="enc__titulo">{carro.note ?? 'Carro estacionado'}</span>
          <span className="mapa__pessoa-familia">
            estacionado às <span className="mono">{hora(carro.parkedAt)}</span> por {carro.parkedBy.memberId === meuMemberId ? 'você' : carro.parkedBy.name}
          </span>
        </span>
        {carro.photoUrl && (
          <button type="button" className="carro__thumb" onClick={() => setAmpliada((v) => !v)} aria-label={ampliada ? 'Fechar foto' : 'Ver foto da fileira'}>
            <img src={carro.photoUrl} alt="" />
          </button>
        )}
      </div>
      {ampliada && carro.photoUrl && <img className="carro__foto" src={carro.photoUrl} alt="Foto da fileira do estacionamento" />}
      <div className="fin__ctas">
        <ComoChegar destino={{ locationName: carro.note ?? 'Carro', latitude: carro.latitude, longitude: carro.longitude }} />
        <button type="button" className="nv-btn nv-btn--primary" disabled={mexendo} onClick={() => void peguei()}>
          Peguei o carro
        </button>
      </div>
    </Card>
  );
}
